import { useCallback, useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import plusIcon from 'assets/plus-outline-gray.svg';

import { infoReactToastify } from 'utlis/toasts';

import styles from './styles.module.scss';

const PersonaDropdown = ({
  isOpen,
  personas,
  highlightedIndex,
  onHover,
  onSelect,
  onCreatePersona,
  canCreatePersona,
}) => {
  const listRef = useRef(null);
  const [isScrollable, setIsScrollable] = useState(false);

  const checkScrollable = useCallback(() => {
    if (listRef.current) {
      setIsScrollable(listRef.current.scrollHeight > listRef.current.clientHeight);
    }
  }, []);

  useEffect(() => {
    if (isOpen) {
      setTimeout(checkScrollable, 0);
    }
  }, [isOpen, personas.length, checkScrollable]);

  if (!isOpen) {
    return null;
  }

  return (
    <div
      className={styles['persona-dropdown']}
      onMouseDown={e => e.preventDefault()}
    >
      <div
        ref={listRef}
        className={cn(styles['persona-list'], {
          [styles['persona-list--scrollable']]: isScrollable,
        })}
      >
        {personas.map((persona, index) => (
          <button
            key={persona.uuid}
            type="button"
            className={cn(styles['persona-item'], {
              [styles['persona-item--highlighted']]: highlightedIndex === index,
            })}
            onMouseEnter={() => onHover(index)}
            onMouseLeave={() => onHover(-1)}
            onMouseDown={e => {
              e.preventDefault();
              onSelect(persona);
            }}
          >
            <span className={styles['persona-item-name']}>
              {persona.name}
            </span>
            <span className={styles['persona-item-desc']}>
              {persona.standard_summary}
            </span>
          </button>
        ))}
      </div>
      <div className={styles['persona-footer']}>
        <button
          type="button"
          className={cn(styles['create-btn'], {
            [styles['create-btn--disabled']]: !canCreatePersona,
          })}
          onMouseDown={e => {
            e.preventDefault();

            if (canCreatePersona) {
              onCreatePersona();
            }
            else {
              infoReactToastify(
                'Add more audience context to create a persona (minimum 140 characters)',
                { autoClose: 3000, position: 'bottom-center', hideProgressBar: true }
              );
            }
          }}
        >
          <img src={plusIcon} alt="" className={styles['create-btn-icon']} />
          Create persona
        </button>
      </div>
    </div>
  );
};

PersonaDropdown.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  personas: PropTypes.arrayOf(PropTypes.shape({
    uuid: PropTypes.string,
    name: PropTypes.string,
    standard_summary: PropTypes.string,
  })).isRequired,
  highlightedIndex: PropTypes.number.isRequired,
  onHover: PropTypes.func.isRequired,
  onSelect: PropTypes.func.isRequired,
  onCreatePersona: PropTypes.func.isRequired,
  canCreatePersona: PropTypes.bool,
};

PersonaDropdown.defaultProps = {
  canCreatePersona: true,
};

export default PersonaDropdown;
